<ng-container>
  <valg-dk-bar-chart
    *ngIf="shouldRenderBarChart"
    [percentage]="value!"
    [number]="number"
    [isPercentage]="!isQuantityChart"
  >
    {{ text }}
  </valg-dk-bar-chart>
  <span *ngIf="!shouldRenderBarChart">{{ defaultValue }}</span>
</ng-container>
